import { Card, styled } from '@mui/material'

const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    borderRadius: '0.5rem',
    backgroundColor: '#ffffff',
    boxShadow: '0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.1)',
    border: 'none',
}))

const DisabledCard = styled(StyledCard)({
    pointerEvents: 'none',
    opacity: 0.66,
})

const CustomCard = ({ children, disabled }) => {
    const CardComponent = disabled ? DisabledCard : StyledCard

    return <CardComponent>{children}</CardComponent>
}

export default CustomCard
